import { sb } from '../supabase';

// Growth OS «تحليل السلوك» — the «never used» list. Every catalogue event is in
// one of four states, so an event the site has never been wired to send is
// never reported as a feature nobody uses:
//   used        — seen in the last N days
//   unused      — the site sends it, and nobody triggered it in N days
//   server      — written by the server (counted the same way)
//   not_wired   — nothing on the website sends it yet (app-only, or not built)
//
// WEB_SENT is what the website's code sends today. A test checks it against
// the source, so adding a track() call without updating this list fails CI.
export const WEB_SENT = [
  'address_submitted', 'auth_method_chosen', 'clarity_session_linked', 'auth_viewed', 'cart_item_added', 'cart_item_qty_changed', 'cart_item_removed',
  'cart_minimum_blocked', 'cart_shipping_changed', 'cart_viewed', 'category_viewed', 'checkout_started', 'checkout_step_viewed', 'home_item_clicked', 'home_section_viewed',
  'image_search_results_shown', 'image_search_started', 'login_completed', 'otp_failed', 'otp_requested', 'otp_verified',
  'page_hidden', 'payment_returned', 'payment_started', 'product_block_seen', 'product_left', 'product_qty_changed',
  'product_qty_table_seen', 'product_variant_changed', 'product_viewed', 'save_upsell_clicked', 'save_upsell_shown',
  'screen_viewed', 'search_abandoned', 'search_result_clicked', 'search_results_shown', 'search_submitted', 'service_fee_shown',
  'service_form_abandoned', 'service_form_field_error', 'service_form_started', 'service_form_step', 'service_submitted',
  'session_started', 'shipping_option_selected', 'shipping_option_viewed', 'signup_completed',
];

const AREA = [
  [/^(session|screen|page)_/, 'التصفح'], [/^home_|^service_entry/, 'الرئيسية'], [/^search_|^list_/, 'البحث'],
  [/^category_/, 'التصنيفات'], [/^image_search/, 'البحث بالصورة'], [/^(product|shipping_option|save_upsell|ask_supplier)/, 'صفحة المنتج'],
  [/^cart_|^checkout_started/, 'السلة'], [/^(checkout|address|payment)/, 'الدفع'], [/^order/, 'طلباتي'], [/^service_/, 'الخدمات'],
  [/^(auth|otp|signup|login)/, 'التسجيل والدخول'], [/^(app_|push_)/, 'التطبيق'],
];
export const areaOf = (name) => (AREA.find(([re]) => re.test(name)) || [null, 'أخرى'])[1];

export function classify(rows) {
  return rows.map((r) => {
    const n = Number(r.n_recent) || 0;
    const state = n > 0 ? 'used' : r.server_only ? 'server' : WEB_SENT.includes(r.event_name) ? 'unused' : 'not_wired';
    return { ...r, n_recent: n, n_all: Number(r.n_all) || 0, state, area: areaOf(r.event_name) };
  });
}

export async function fetchFeatureUse(days = 30) {
  const { data, error } = await sb.rpc('growth_event_counts', { p_days: days });
  if (error) throw error;
  return classify(data || []);
}

// The same four states for any window [start, end) (ms) — the range picker's.
export async function fetchFeatureUseBetween(start, end) {
  const { data, error } = await sb.rpc('growth_event_counts_between', { p_from: new Date(start).toISOString(), p_to: new Date(end).toISOString() });
  if (error) throw error;
  return classify((data || []).map((r) => ({ ...r, n_recent: r.n })));
}

// «لم يُستخدم» says something only once tracking covers the whole period: the
// owner's rule is from 1 Dec 2026 (30 days of tracking), and never for a
// period that starts before tracking did.
export const TRACKING_FROM_DAY = '2026-11-01';
export const UNUSED_FROM_DAY = '2026-12-01';
export const showUnused = (range, today) => today >= UNUSED_FROM_DAY && range.from >= TRACKING_FROM_DAY;
